import { API } from "config/api";
import { API_ROUTES } from "config/apiRoutes";
import { MissingCognitoUser } from "services/cognitoProvisioning";

export type SyncCognitoAttributesResponse = {
  user_id: string;
  email: string;
  updatedAttributes: string[];
};

export async function fetchUsersNeedingCognitoAttributeSync(): Promise<{
  users: MissingCognitoUser[];
  count: number;
}> {
  const { data } = await API.get(API_ROUTES.USERS.MISSING_COGNITO_ATTRIBUTES());
  return data;
}

export async function syncCognitoUserAttributes(
  userId: string
): Promise<SyncCognitoAttributesResponse> {
  const { data } = await API.post(API_ROUTES.USERS.SYNC_COGNITO_ATTRIBUTES(), {
    userId,
  });
  return data;
}
